import React from "react";
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, IconButton, Tooltip,
  Typography, Box, Paper
} from "@mui/material";
import { Edit, Assignment, Delete, Download } from "@mui/icons-material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { deleteDoc, doc } from "firebase/firestore";
import { firestore as db } from "../../firebase";

const AdminChecklistView = ({ tasks, onEdit, onAssign }) => {

  const handleDeleteChecklist = async (id) => {
    await deleteDoc(doc(db, "checklists", id));
  };

  const generatePDF = (checklist) => {
    const docPDF = new jsPDF();

    const headers = checklist.columns.map((col) => col.name);
    const rows = checklist.rows.map((row) =>
      checklist.columns.map((col) => row.data[col.id] || "")
    );

    docPDF.text(checklist.name, 10, 10);

    autoTable(docPDF, {
      head: [headers],
      body: rows,
      startY: 20,
      theme: "grid",
    });

    let yOffset = docPDF.lastAutoTable.finalY + 10;

    if (checklist.remarks) {
      docPDF.text(`Remarks: ${checklist.remarks}`, 10, yOffset);
      yOffset += 10;
    }

    docPDF.save(`${checklist.name || "Checklist"}.pdf`);
  };

  return (
    <Box mb={3}>
      <Typography variant="h5" gutterBottom>
        Created Checklists
      </Typography>
      <Paper sx={{ padding: "1rem", backgroundColor: "#f5f5f5" }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks.map((checklist) => (
                <TableRow key={checklist.id}>
                  <TableCell>{checklist.name}</TableCell>
                  <TableCell>{checklist.description}</TableCell>
                  <TableCell>
                    <Tooltip title="Edit">
                      <IconButton
                        color="primary"
                        onClick={() => onEdit(checklist)}
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Assign">
                      <IconButton
                        color="info"
                        onClick={() => onAssign(checklist)}
                      >
                        <Assignment />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton
                        color="error"
                        onClick={() => handleDeleteChecklist(checklist.id)}
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Download">
                      <IconButton
                        color="secondary"
                        onClick={() => generatePDF(checklist)}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default AdminChecklistView;
